module.exports = __webpack_public_path__ + "static/media/temp_31.06e8a81f.jpg";